module.exports = __webpack_public_path__ + "img/step2.6234022b.png";